
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import * as R from "ramda";
import $ from 'jquery';
import parsePhoneNumber from 'libphonenumber-js';
import countriesList from 'iso-3166-1-alpha-2';
import countryTelData from 'country-telephone-data';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { CreateTeleconseillerByPartnerId, UpdateTeleconseillerByPartnerId } from '../../actions/funecap/teleconseiller';

export const EditUser = ({ selectedClient, partner, etablissement }) => {
    const dispatch = useDispatch();
	const history = useHistory();
    var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const formRef = useRef();
    const buttonRef = useRef();
    const initValue = !R.isNil(selectedClient) ? { ...selectedClient } : {
		firstName: '',
		lastName: '',
		email: '',
		phoneNumber: '',
		countryCode: '33',
		phoneCountry: 'FR',
		isEnabled: true,
		partnerId: R.isNil(partner) ? undefined : partner.id,
		etablissementId: R.isNil(etablissement) ? undefined : etablissement.id,
		daysOfTraining: 0,
		roles: ["partner"]

	};
    if (!R.isNil(selectedClient) && selectedClient.phoneNumber!="") {
		const phone = parsePhoneNumber(selectedClient.phoneNumber);
		if (!R.isNil(phone)) {
			initValue.phoneNumber = phone.nationalNumber;
			initValue.countryCode = phone.countryCallingCode;
			initValue.phoneCountry = phone.country;
		}
	}
	const [role, setRole] = useState(!R.isNil(initValue.roles) && initValue.roles.indexOf('partner') > -1 ? "PARTNER" : "ETABLISSEMENT");
    const [userInfo, setUserInfo] = useState(initValue);
    function resetForm() {
		formRef.current.classList.remove('was-validated');
		setUserInfo(initValue);
		setRole(initValue.roles.indexOf('partner') > -1 ? "PARTNER" : "ETABLISSEMENT");
	}

    useEffect(() => {
        
		if (R.isNil(selectedClient)) {
			resetForm();
		} else {
			const user = { ...selectedClient };
            if(selectedClient.phoneNumber != ""){
                const phone = parsePhoneNumber(selectedClient.phoneNumber);
                if (!R.isNil(phone)) {
                    user.phoneNumber = phone.nationalNumber;
                    user.countryCode = phone.countryCallingCode;
                    user.phoneCountry = phone.country;
                }
            }
			setUserInfo(user);
			setRole(user.roles.indexOf('partner') > -1 ? "PARTNER" : "ETABLISSEMENT");
		}

	}, [selectedClient]);
    return (
        <div className="modal fade px-0" id="userAccount" aria-labelledby="userAccountLabel" aria-hidden="true" >
				<div className="modal-dialog px-2">
					<div className="modal-content">
						<header className="modal-header">
							<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">User Account Donnes</h1>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="userAccountLabel">Données du compte utilisateur</div>
									<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
										<i className="eva eva-close fs-4"></i>
									</button>
								</div>
							</div>
						</header>
						<div className="modal-body scroll-default py-0">
							<section className="card card-body bg-light rounded">
								<form className="form" noValidate id="useraccountForm" ref={formRef}>
									<div className="form-group">
										<div className="form-row">
											<div className="form-group col">
												<label className="h6 font-weight-bolder" htmlFor="Prenom">Prénom *</label>
												<input required type="text" className="form-control" id="Prenom" value={userInfo.firstName} onChange={(e) => setUserInfo({ ...userInfo, firstName: e.target.value })} />
											</div>
											<div className="form-group col">
												<label className="h6 font-weight-bolder" htmlFor="Nom">Nom *</label>
												<input required type="text" className="form-control" id="Nom" value={userInfo.lastName} onChange={(e) => setUserInfo({ ...userInfo, lastName: e.target.value })} />
											</div>
										</div>
										<label className="h6 font-weight-bolder lh-root" htmlFor="telephone">Numéro de téléphone de l'utilisateur</label>

										<div className="input-group mb-0">
										
											{/* <select className="custom-select rounded container-paper container-sm-tiny mr-2" id="naturalite" tabIndex={-98} value={selectedClient.country} onChange={(e) => setSelectedClient({ ...selectedClient, country: e.target.value })}> */}
											{/* <option key={"index"} value={'+'}>{'countries.getName(country, "fr", { select: "official" })'} (+{'dialCode'})</option> */}
											{/* <option value={'+'}>{countries.getName(country, "fr", { select: "official" })}</option> */}
											{/* {
													Object.keys(countriesList.getData()).map((country, index) => {
														return (
															<option key={index} value={country}>{countries.getName(country, "fr", { select: "official" })}</option>
														);
													})
												} */}
											{/* </select> */}
											<select className="custom-select rounded container-tiny mr-2" id={"phonecode"} tabIndex={-98} value={userInfo.countryCode} onChange={(event) => {
												let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
												setUserInfo({ ...userInfo, countryCode: event.target.value, phoneCountry: pc });
											}}>
												{
													Object.keys(countriesList.getData()).map((country, index) => {
														let dialCode = countryTelData.allCountries[countryTelData.iso2Lookup[country.toLowerCase()]].dialCode;

														return (
															<option key={index} value={dialCode}>{countries.getName(country, "fr", { select: "official" })} (+{dialCode})</option>
														);
													})
												}
											</select>
											<input required type="tel" className="form-control rounded" id={"phone"} placeholder="00 00 00 00 00" value={R.isNil(userInfo.phoneNumber) ? null : parsePhoneNumber(userInfo.phoneNumber, userInfo.phoneCountry) !== undefined ? parsePhoneNumber(userInfo.phoneNumber, userInfo.phoneCountry).formatNational() : userInfo.phoneNumber} aria-describedby="telephoneHelpBlock"
												onChange={(e) => {
													const phoneInput = document.getElementById("phone");
													const parsedPhoneNumber = parsePhoneNumber("+" + userInfo.countryCode + e.target.value);
													if (R.isNil(parsedPhoneNumber) || !isValidPhoneNumber(parsedPhoneNumber.number)) {
														phoneInput.setCustomValidity("Numéro de télephone invalide.");
													} else {
														phoneInput.setCustomValidity("");

													}

													setUserInfo({ ...userInfo, phoneNumber: e.target.value });
												}} />
											{/* <input required type="tel" className="form-control rounded" id="telephone" placeholder="00 00 00 00 00" value={selectedClient.phoneNumber} onChange={(e) => setSelectedClient({ ...selectedClient, phoneNumber: e.target.value })} /> */}
											<div className="w-100 mb-1 d-md-none"></div>
											{/* <span className="input-group-text p-0 ml-md-1 border-none"><button className="btn btn-info rounded-inherit px-sm" >Envoyer code</button></span> */}
											<div className="invalid-feedback alert bg-alert-danger mt-2 mb-4">
												<i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
												<span className="align-middle text-dark o-70">Valider votre numéro de téléphone</span>
											</div>
										</div>
										<p className="form-text small text-gray mt-2" id="telephoneHelpBlock"><i className="eva eva-info-outline text-info mr-1 fs-sm lh-root align-middle"></i><span className="align-middle">Nous utiliserons ce numéro pour assurer la sécurité de votre compte.</span></p>
									</div>
									<div className="form-group">
										<label className="h6 font-weight-bolder" htmlFor="email">Utilisateur e-mail</label>
										<input type="email" className="form-control" id="email" placeholder="votreemail@mail.fr" value={userInfo.email} onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })} required pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" />
										<div className={"invalid-feedback"}>
											Champs invalide
										</div>
									</div>
									<div className="form-group">
										<label className="h6 font-weight-bolder" htmlFor="statut">Rôle</label>
										<select className="custom-select" id="statut" tabIndex={-98} value={role} onChange={(e) => setRole(e.target.value)}>
											<option value="PARTNER" >Administrateur</option>
											<option value="ETABLISSEMENT" >Chargé</option>
										</select>
									</div>
									<div className="form-group mb-0">
										<label className="h6 font-weight-bolder" htmlFor="statut">Statut d'utilisateur</label>
										<select className="custom-select" id="statut" tabIndex={-98} value={userInfo.isEnabled ? "actif" : "desactivé(e)"} onChange={(e) => setUserInfo({ ...userInfo, isEnabled: userInfo.isEnabled ? false : true })}>
											<option value="actif" >Actif</option>
											<option value="desactivé(e)" >Desactivé(e)</option>
										</select>
									</div>
								</form>
							</section>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-light" data-dismiss="modal">Fermer</button>
							<button type="button" className="btn btn-info" onClick={
									(e) => {
										e.preventDefault();
										let internationalPhoneNumber = null;
										if(!R.isNil(userInfo.phoneNumber) && !R.isEmpty(userInfo.phoneNumber)){
											internationalPhoneNumber = parsePhoneNumber(userInfo.phoneNumber, userInfo.phoneCountry);
											if (R.isNil(internationalPhoneNumber) || !internationalPhoneNumber.isValid()) {
												document.getElementById("phoneNumberInput").setCustomValidity("Le numéro de téléphone n'est pas valide.");
											}
										}
										if (formRef.current.checkValidity()) {
											if (R.isNil(userInfo.id)) {
												dispatch(CreateTeleconseillerByPartnerId({ ...userInfo, phoneNumber: R.isNil(internationalPhoneNumber) ? null : internationalPhoneNumber.number }, partner.id, role))
													.then(() => {
														$('.modal').modal("hide");
														resetForm();
													});
											} else {
												dispatch(UpdateTeleconseillerByPartnerId({ ...userInfo, phoneNumber: R.isNil(internationalPhoneNumber) ? null : internationalPhoneNumber.number, professionalSituation: 'Employed', etablissementId: etablissement.id }, partner.id, role))
													.then(() => {
														$('.modal').modal("hide");
														resetForm();
														history.push(`/funecap/teleconseillers${window.location.search}`);
													});
											}
										}
										formRef.current.classList.add('was-validated');
									}
								}>Enregistrer</button>
						</div>
					</div>
				</div>
			</div>
    )
}